import React, { useCallback } from 'react';

import type { Sort } from 'stores/PaginationTypes';
import { PaginatedEntityTable } from 'components/common';
import type { CollectionListItem } from 'collections/types';
import { fetchPaginatedCollections, keyFn } from 'collections/hooks/useCollections';

import CollectionActions from './CollectionActions';
import customColumnRenderers from './customColumnRenderers';
import BulkActions from './BulkActions';

export const DEFAULT_LAYOUT = {
  entityTableId: 'collections',
  defaultPageSize: 20,
  defaultSort: { attributeId: 'title', direction: 'asc' } as Sort,
  defaultDisplayedAttributes: ['title', 'description', 'shared_with_users', 'shared_with_teams'],
};

const COLUMNS_ORDER = ['title', 'description', 'shared_with_users', 'shared_with_teams'];

const bulkSelection = {
  actions: <BulkActions />,
};

const CollectionsList = () => {
  const collectionActions = useCallback(
    ({ id, title }: CollectionListItem) => <CollectionActions id={id} title={title} />,
    [],
  );

  return (
    <PaginatedEntityTable<CollectionListItem>
      actionsCellWidth={250}
      humanName="collections"
      columnsOrder={COLUMNS_ORDER}
      entityActions={collectionActions}
      tableLayout={DEFAULT_LAYOUT}
      fetchEntities={fetchPaginatedCollections}
      keyFn={keyFn}
      columnRenderers={customColumnRenderers}
      entityAttributesAreCamelCase={false}
      searchPlaceholder="Search for collection"
      bulkSelection={bulkSelection}
    />
  );
};

export default CollectionsList;
